module.exports = __webpack_public_path__ + "img/flash_sale_preview.6630c264.svg";